module.exports = __webpack_public_path__ + "static/media/her.37588412.png";